<style scoped>
  .like {
    border-bottom:1px solid #f0efef;
    padding: 5px 10px 5px 15px;
    justify-content: flex-start;
  }
  .bookmark {
    height:16px;
    width:18px;
    margin-right:0px;
  }
</style>


<template>
  <div class="flex-container direction-col">
    <div class="order-2 direction-row center" style="justify-content:space-between; width:100%; padding:15px 0; border-bottom:1px solid #cfcfcf;">
      <div class="order1 direction-row center">
        <a style="padding-left:20px;height:20px;line-height:20px">
            <img style="height: 21px; width: 15px; margin-top: -1px; display: inline; vertical-align: middle;" :src="likeSolidImg"/>
        </a>
        <!-- <Icon size="20" style="color:#2d8cf0;" type="thumbsup" /> -->
        <!-- <h4>&nbsp; {{users.length}}</h4> -->
        <h4>&nbsp; {{count}}</h4>
      </div>
      <h4 class="order-3">People who liked</h4>
      <!-- <div class="order-4"></div> -->
      <!-- <div class="order-5"></div> -->
      <img alt=" " @click="closeLikeModal" class="order-4" style="margin-right:10px;height:25px; width:25px;" src="@/assets/close.png">
    </div>
    <div class="order-3 direction-col like" style="width:100%;" v-for="(user, index) in users" :key="index">
      <div class="direction-row center">
        <router-link tag="div" :to="'/profile/'+ user.id">
          <Avatar class="order-1" icon="ios-person" size="large" :src="userDisplayImage(user)"/>
        </router-link>
        <router-link tag="div" :to="'/profile/'+ user.id">
          <h5 class="order-2" style="padding-left:10px;">{{ user.display_name }}</h5>
        </router-link>
        <!-- <img v-if="!(bookmarking && bookmarkingId==user.id) && !mySelf(user.id) && youveBookmarkIt(user.id)" @click="bookmark(user.id)" class="order-3 bookmark" style="margin-left:auto;margin-right:5px;" src="@/assets/icons8-bookmark-filled-50.png">
        <img v-else-if="!(bookmarking && bookmarkingId==user.id) && !mySelf(user.id)" class="order-3 bookmark" @click="bookmark(user.id)" style="margin-left:auto;margin-right:5px;" src="@/assets/icons8-bookmark-50.png">
        <Button v-if="bookmarking && bookmarkingId==user.id" loading shape="circle" type="text" disabled style="margin-left:auto;margin-right:0px;" ></Button> -->
      </div>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import Utils from '@/utils.js'
import likeSolidImg from '@/assets/svg/thumbs-up-solid.svg'

export default {
  name: 'LikeComponent',
  props: {
    users: { type: Array, required: true }
  },
  data() {
    return {
      bookmarkingId:'',
      likeSolidImg
    }
  },
  computed: {
    count: function() {
      let ctr = 0;
      try {
        ctr = this.users.length;
      } catch {}
      return ctr;      
    },
    bookmarking: function() {
      return this.$store.state.user.isLoadingBookmark
    },
    currentUserId: {
      get() {
        return this.$store.state.user.info.id;
      }
    },
    youveBookmarkIt: function() {
      return function(id) {
        let bookmarked = _.find(this.$store.state.user.userBookmarks.data, ['type','person']);
        console.log('person bookmarked...' + id, [bookmarked]);
        if (bookmarked==undefined) return false;
        var found = _.find(bookmarked, ['id',id]);
        return found!=undefined;
      }
    }
  },
  methods: {
    closeLikeModal: function() {
      BroadcastEvent.$emit('closeLikeModal');
    },
    bookmark (id) {
      this.bookmarkingId=id;
      this.$store.dispatch('user/setPublicProfileBookmark')
    },
    viewProfile: function(id) {
      this.$router.push({ path: '/resources/' + id })
    },
    mySelf: function(id) {
      return id==this.currentUserId;
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    }
  },
	components: {likeSolidImg },
// 	data() { return {} },
// 	watch: { },
}

</script>
